<template>
	<div class="bg">
		<!-- <imnav></imnav> -->
		<div class="nav">
			<div @click="test()" class="navbox">
				<img style="width: 110px;height: 40px;" src="../../public/img/logo.png" />
				<div style="width: 700px;display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
					<router-link to="/">
						<div style="color: #3A8EE6">返回首页</div>
					</router-link>
					
					<a href="https://hisay.im/document.docx" style="font-size: 16px;color: #3A8EE6">下载文档</a>
					<el-dropdown>
					  <span class="el-dropdown-link">
					    <span  style="color: #3A8EE6;font-size: 16px;">下载sdk</span><i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <a  href="https://hisay.im/public/PHPSDK.zip" style="color: #3A8EE6;margin-left: 20px;margin-right: 20px;">PHP-SDK下载</a>
					  </el-dropdown-menu>
					</el-dropdown>
					<a href="https://hisay.im/public/HisayUI.zip" style="font-size: 16px;color: #3A8EE6">下载案例</a>
					<!-- <div>控制台</div> -->
				</div>
			</div>
		</div>
		<div class="box">
			<div class="left">
				<el-row class="tac">
					<el-col :span="24">
						<h3  style="color: #3A8EE6">使用文档</h3>
						<el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" background-color="rgba(0,0,0,0)"
						 @close="handleClose" :default-openeds='myindex'>
							<el-submenu v-for="(item,index) in data" :key="index" :index="index+''">
								<template slot="title">
									<span class="title1">{{item.name}}</span>
								</template>
								<el-menu-item-group style="margin-top: -20px;">
									<el-menu-item style="height: 40px;" @click="handleLeft(index+''+index1,item1.name)" v-for="(item1,index1) in item.child"
									 :key="index1">
										<template slot="title">
											<span style="height: 30px;opacity: 0.8;" :class="{'isActive': (index+''+index1)==navgatorIndex}">{{item1.name}}</span>
										</template>
									</el-menu-item>
								</el-menu-item-group>
							</el-submenu>
						</el-menu>
					</el-col>
				</el-row>
			</div>
			<div id="right" class="right">
				<div class="child-title" v-for="(item,index) in data" :key="index">
					<div :id="'ids'+(index+''+index1)" v-for="(item1,index1) in item.child" :key="index1">
						<!-- <h4 :id="'id'+(item1.name+index1)">{{item1.name}}</h4> -->
						<div class="child-title" v-for="(item2,index2) in item1.child" :key="index2">
							<h4 style="padding-top: 20px;color: #3A8EE6" :id="'id'+(index+''+index1)">{{item2.name}}</h4>
							<div v-for="(item3,index3) in item2.child" :key="index3">
								<p v-if="item3.type=='text'" v-html="item3.data" style="width: 55vw;color: #5e6d82;font-size: 14px;"></p>
								<div v-if="item3.type=='img'" style="width: 55vw;">
									<img :src="item3.data" />
								</div>
								<div v-if="item3.type=='table'">
									<el-table style="width: 55vw" :data="item3.data.row" border>
										<el-table-column  v-for="(item4,index4) in item3.data.col" :key="index4"
										 :prop="item4.prop" :label="item4.label" >
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import imnav from "../components/nav.vue"
	import data from "../../public/img/data.js"
	import myfun from '../assets/myfun.js';
	export default {
		components: {
			imnav
		},
		data() {
			return {
				navgatorIndex: 0,
				myindex: [],
				listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
				data: []
			}
		},
		created() {
			this.data = data
			this.data.forEach((item, index) => {
				this.myindex.push(index + '')
			})
		},
		mounted() {
			
			let timeId;
			document.getElementById('right').addEventListener('scroll', () => {
				// 页面滚动停止100毫秒后才会执行下面的函数。
				clearTimeout(timeId);
				timeId = setTimeout(() => {
					this.scrollToTop();
					console.log('执行完了哦');
				}, 100);
			}, true);
		},
		methods: {
			test(){
				myfun.$emit('login')
			},
			handleLeft(index, name) {
				console.log(1223)
				this.navgatorIndex = index;

				this.$el.querySelector(`#id${index}`).scrollIntoView({
					// behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
				this.listBoxState = false;

				let timeId;
				clearTimeout(timeId);
				timeId = setTimeout(() => {
					this.listBoxState = true;
				}, 200);
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			// 监听页面元素滚动，改变导航栏选中
			scrollToTop() {
				// 获取视窗高度
				var domHight = document.getElementById('right').offsetHeight;
				// dom滚动位置
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.getElementById('right').scrollTop;
				// console.log(scrollTop)
				if (this.listBoxState) { //作用是点击导航栏时，延迟这里执行。
					this.data.map((item, index) => {
						item.child.map((v, i) => {
							var offsetTop = document.getElementById(`ids${index+''+i}`).offsetTop - 150;
							// console.log(offsetTop)
							// 获取监听元素本身高度
							var scrollHeight = document.getElementById(`ids${index+''+i}`).scrollHeight;

							// 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
							// 则表示页面已经滚动到可视区了。
							
							if (scrollTop >= offsetTop && scrollTop <= (offsetTop + scrollHeight)) {
								// 导航栏背景色选中
								this.navgatorIndex = index+''+i;
								console.log(this.navgatorIndex)
							}
						})
						// 获取监听元素距离视窗顶部距离

					})
				}
			},
		}

	}
</script>

<style scoped="scoped">
	a{
		text-decoration: none;
	}
	.navbox{
		width: 80vw;
		height: 100%;
		border-bottom: 1px solid rgba(0,0,0,0.1);
		/* background-color: #0F73EE; */
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
	}
	.nav{
		width: 100vw;
		height: 10vh;
		display: flex;
		justify-content: center;
		flex-direction: row;
		box-sizing: border-box;
	}
	.isActive {
		color: #3A8EE6;
	}

	.title1 {
		font-weight: 600;
		font-size: 14px;
	}

	.child-title {
		margin-left: 20px;
	}

	.bg {
		width: 100vw;
		height: 100vh;
		display: flex;
		/* align-items: center; */
		flex-direction: column;
		box-sizing: border-box;
	}

	.box {
		height: 90vh;
		width: 90vw;
		/* background-color: #13CE66; */
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-left: 10vw;
	}

	.left {
		height: 88vh;
		width: 18vw;
		/* background-color: #B3D8FF; */
		/* overflow: scroll; */
		overflow-x: hidden;
		padding-left: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		overflow-y: hidden;
		opacity: 0.5;
		transition: 1s;
		padding-bottom: 40px;
		margin-top: 2vh;
	}

	.right {
		height: 88vh;
		width: 72vw;
		/* background-color: #2C3E50; */
		/* overflow: scroll; */
		overflow-x: hidden;
		padding-left: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		margin-top: 2vh;
	}

	.left:hover {

		overflow-y: auto;

		opacity: 1;
	}

	/*滚动条样式*/
	.left::-webkit-scrollbar {
		width: 4px;
		/*height: 4px;*/
	}

	.left::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background: #3A8EE6;
	}

	.left::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		border-radius: 10px;
		background: rgba(0, 0, 0, 0.1);

	}

	/*滚动条样式*/
	.right::-webkit-scrollbar {
		width: 4px;
		/*height: 4px;*/
	}

	.right::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background: #3A8EE6;
	}

	.right::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		border-radius: 10px;
		background: rgba(0, 0, 0, 0.1);

	}

	.el-menu-item:hover {
		background: rgba(0, 0, 0, 0) !important;
		color: #3A8EE6 !important;
	}

	.el-submenu:hover {
		background: rgba(0, 0, 0, 0) !important;
		/* color: #3A8EE6 !important; */
	}

	.el-submenu__title:hover {
		background: rgba(0, 0, 0, 0) !important;
	}
</style>
